import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-black-card-style2',
  templateUrl: './black-card-style2.component.html',
  styleUrls: ['./black-card-style2.component.css']
})
export class BlackCardStyle2Component implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
